// src/pages/CancellationPolicyPage.tsx
import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiRefreshCw } from "react-icons/fi";
import { usePageTitle } from "../hooks/usePageTitle";

const CancellationPolicyPage: React.FC = () => {
	usePageTitle("キャンセル・返金ポリシー");

	return (
		<div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
			<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
				{/* Header */}
				<div className="mb-8">
					<Link
						to="/"
						className="inline-flex items-center text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 mb-4"
					>
						<FiArrowLeft className="w-4 h-4 mr-1" />
						トップページに戻る
					</Link>
					<div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-8">
						<div className="flex items-center gap-4 mb-4">
							<div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full">
								<FiRefreshCw className="w-6 h-6 text-white" />
							</div>
							<div>
								<h1 className="text-3xl font-bold text-gray-900 dark:text-white">
									キャンセル・返金ポリシー
								</h1>
								<p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
									最終更新日: 2026年3月22日
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Content */}
				<div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-8">
					<div className="prose prose-gray dark:prose-invert max-w-none">
						<section className="mb-8">
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								本ポリシーは、合同会社blackadder（以下「当社」といいます）が運営するイベントチケット販売プラットフォーム「b+
								ticket」（以下「本サービス」といいます）における、チケットのキャンセル・返金に関する取扱いを定めるものです。
							</p>
						</section>

						<section className="mb-8">
							<h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
								第1条（基本方針）
							</h2>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								電子チケットという商品の性質上、購入完了後のお客様のご都合によるキャンセル・返金は原則としてお受けしておりません。
								ご購入の際は、イベント内容・日時・会場等をよくご確認の上、お申し込みください。
							</p>
						</section>

						<section className="mb-8">
							<h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
								第2条（返金が認められる場合）
							</h2>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								以下の場合に限り、返金対応をいたします。
							</p>
							<div className="mb-4">
								<h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
									1. 主催者都合によるイベントの中止
								</h3>
								<p className="text-gray-700 dark:text-gray-300 leading-relaxed ml-4">
									主催者の判断によりイベントが中止された場合、チケット代金の全額を返金いたします。
									返金処理は、イベント中止の決定後、当社にて速やかに手続きを行います。
								</p>
							</div>
							<div className="mb-4">
								<h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
									2. イベントの延期
								</h3>
								<p className="text-gray-700 dark:text-gray-300 leading-relaxed ml-4">
									イベントの開催日時が変更（延期）された場合、変更後の日程でご参加いただけない方には返金対応をいたします。
									返金をご希望の場合は、主催者が定める期限内にお申し出ください。
								</p>
							</div>
							<div className="mb-4">
								<h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
									3. 二重決済等のシステムエラー
								</h3>
								<p className="text-gray-700 dark:text-gray-300 leading-relaxed ml-4">
									システムの不具合により、同一チケットに対して二重に決済が行われた場合、重複分を返金いたします。
								</p>
							</div>
							<div className="mb-4">
								<h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
									4. その他当社が認めた場合
								</h3>
								<p className="text-gray-700 dark:text-gray-300 leading-relaxed ml-4">
									上記に該当しない場合であっても、当社が返金が相当と判断した場合は、個別に対応いたします。
								</p>
							</div>
						</section>

						<section className="mb-8">
							<h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
								第3条（返金方法）
							</h2>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								1.
								返金は、原則としてご購入時にご利用いただいた決済手段への返金（クレジットカードへの返金処理）にて行います。
							</p>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								2.
								返金処理完了後、実際にお客様の口座等に反映されるまでの期間は、ご利用のクレジットカード会社の締日・支払日により異なります。通常、返金処理後1〜2ヶ月程度を要する場合があります。
							</p>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								3.
								サービス手数料については、イベント中止の場合は全額返金いたします。お客様都合の場合は返金対象外となります。
							</p>
						</section>

						<section className="mb-8">
							<h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
								第4条（返金の手続き）
							</h2>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								1.
								イベント中止・延期に伴う返金は、当社より対象のお客様へメールにてご案内いたします。
							</p>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								2.
								二重決済等の返金をご希望の場合は、以下の情報を添えて、お問い合わせ先メールアドレスまでご連絡ください。
							</p>
							<ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 ml-4 mb-3">
								<li>ご登録のお名前</li>
								<li>ご登録のメールアドレス</li>
								<li>購入したイベント名</li>
								<li>購入日時</li>
								<li>返金を希望する理由</li>
							</ul>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed">
								3.
								当社にて内容を確認の上、返金の可否を判断し、結果をメールにてお知らせいたします。
							</p>
						</section>

						<section className="mb-8">
							<h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
								第5条（返金ができない場合）
							</h2>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								以下の場合は、返金をお受けできません。
							</p>
							<ol className="list-decimal list-inside space-y-2 text-gray-700 dark:text-gray-300 ml-4">
								<li>
									お客様の個人的なご都合（予定変更、気が変わった等）によるキャンセル
								</li>
								<li>
									イベント開催後のキャンセル（来場されなかった場合を含む）
								</li>
								<li>
									購入されたチケットを第三者に譲渡・転売した場合
								</li>
								<li>
									天災、感染症の流行、交通機関の運休等の不可抗力によりお客様がイベントにご参加いただけなかった場合（ただし、主催者がイベントを中止した場合を除く）
								</li>
								<li>
									当社が定める返金申請期限を過ぎた場合
								</li>
							</ol>
						</section>

						<section className="mb-8">
							<h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
								第6条（主催者による独自のキャンセルポリシー）
							</h2>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								主催者が独自のキャンセルポリシーを定めている場合、そのポリシーが本ポリシーに優先して適用されることがあります。
								各イベントページに記載されたキャンセルポリシーを必ずご確認ください。
							</p>
						</section>

						<section className="mb-8">
							<h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
								第7条（お問い合わせ）
							</h2>
							<p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3">
								キャンセル・返金に関するお問い合わせは、以下までご連絡ください。
							</p>
							<div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4">
								<p className="text-gray-700 dark:text-gray-300">
									合同会社blackadder
								</p>
								<p className="text-gray-700 dark:text-gray-300">
									メール:{" "}
									<a
										href="mailto:info@blackadder.co.jp"
										className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"
									>
										info@blackadder.co.jp
									</a>
								</p>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CancellationPolicyPage;
